import React, { useEffect, useState } from "react";
import { Favourite, Profile, cart } from "../../../assets/svgIcons";
import "./style.css";
import UseCartFavourite from "../../../hooks/useCartFavourite";
import { useNavigate } from "react-router-dom";
import { Axios } from "../../../Axios";
import { BASE_URL } from "../../../Axios/base_url";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
const HeaderIcons = () => {
  const cartLength = useSelector((state) => state.cart.data);
  const [cartNumber, setCartNumber] = useState(0);
  const {
    cart: cart_2,
    favourite,
    totalPrice,
    CartNumber,
    // getUserData,
    allCart,
  } = UseCartFavourite({ setCartNumber });
  const navigate = useNavigate();
  const localCartLength = useSelector((state) => state.offlineCart);
  
  return (
    <div className="HeaderIcons">
      <span onClick={() => navigate("/Cart")}>
        {totalPrice > 0 ? <sub>{totalPrice}$</sub> : null}
        {cart}
        {/* {CartNumber} */}
        {<sup>{Array.isArray(localCartLength.items)?localCartLength.items.length:0}</sup>}
      </span>
      <span onClick={() => navigate("/Favourite")}>
        {Favourite}
        {favourite?.length > 0 ? <sup>{favourite?.length}</sup> : null}
      </span>
      <span
        onClick={() =>
          navigate(
            localStorage?.getItem("GreenTreesToken") ? "/profile" : "/login"
          )
        }
      >
        {Profile}
      </span>
    </div>
  );
};

export default HeaderIcons;
